import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios, { axiosBuzzOne } from '../../../../axios';
import { moduleName } from '../../moduleInfo';
import {
  createAdmissionFormFeeRoute,
  viewAdmissionFormFeesRoute,
  getApprovalsDiscoveryRoute,
  getApprovalsDiscoveryPanelRoute,
} from '../../utils/apiRoutes';
import { AUTH_TOKEN } from '../../../../environments';

export const getApprovalsDiscoveryPanelAsync = createAsyncThunk(
  `${moduleName}/getApprovalsDiscoveryPanelAsync`,
  async (payload) => {
    const { sortby } = payload;
    const response = await axios({
      method: 'GET',
      url: getApprovalsDiscoveryPanelRoute(),
      headers: {
        Authorization: AUTH_TOKEN,
      },
      params: {
        sortby,
      },
    });
    const data = response.data;
    return data;
  }
);

export const setAdmissionFeeAsync = createAsyncThunk(
  `${moduleName}/setAdmissionFee`,
  async (payload) => {
    const { admissionFormFees, schoolId } = payload;
    console.log('test', payload);
    const response = await axios({
      method: 'PUT',
      url: createAdmissionFormFeeRoute(schoolId),
      data: { admissionFormFees },
    });
    const data = response.data;
    return data;
  }
);

export const viewAdmissionFeeAsync = createAsyncThunk(
  `${moduleName}/viewAdmissionFee`,
  async () => {
    // const { schoolId } = payload;
    const response = await axios({
      method: 'GET',
      url: viewAdmissionFormFeesRoute(),
    });
    const data = response.data;
    return data;
  }
);

export const getApprovalsDiscoveryAsync = createAsyncThunk(
  `${moduleName}/getApprovalsDiscoveryAsync`,
  async (payload) => {
    const response = await axiosBuzzOne({
      method: 'GET',
      url: getApprovalsDiscoveryRoute(),
      params: payload,
    });
    const data = response.data;
    return data;
  }
);

const admissionFeeSlice = createSlice({
  name: `${moduleName}/admissionFee`,
  initialState: {
    loading: false,
    admissionFormFees: undefined,
    admissionFormFeesList: undefined,
    approvalsDiscovery: null,
    ApprovalsDiscoveryPanel: null,
    approvalsTable: null,
    mgmentPanel: null,
  },
  reducers: {},
  extraReducers: {
    [setAdmissionFeeAsync.pending]: (state, action) => {
      state.loading = true;
      //todo
    },
    [setAdmissionFeeAsync.fulfilled]: (state, action) => {
      state.loading = false;
      //todo
    },
    [setAdmissionFeeAsync.rejected]: (state, action) => {
      state.loading = false;
      //todo
    },
    [viewAdmissionFeeAsync.pending]: (state, action) => {
      state.loading = true;
      //todo
    },
    [viewAdmissionFeeAsync.fulfilled]: (state, action) => {
      state.loading = false;
      console.log('action.payload.data', action.payload.data);
      state.admissionFormFees = action.payload.data.admissionFormFees;
      state.admissionFormFeesList = action.payload.data;
      //todo
    },
    [viewAdmissionFeeAsync.rejected]: (state, action) => {
      state.loading = false;
      //todo
    },
    [getApprovalsDiscoveryAsync.pending]: (state, action) => {
      state.loading = true;
    },
    [getApprovalsDiscoveryAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.approvalsTable = action.payload.data;
    },
    [getApprovalsDiscoveryAsync.rejected]: (state, action) => {
      state.loading = false;
    },
    [getApprovalsDiscoveryPanelAsync.pending]: (state) => {
      state.loading = true;
    },
    [getApprovalsDiscoveryPanelAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.mgmentPanel = action.payload.data;
    },
    [getApprovalsDiscoveryPanelAsync.rejected]: (state) => {
      state.loading = false;
    },
  },
});

export default admissionFeeSlice.reducer;
